import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import { Id } from 'types/definitions'
import { match } from 'utils/pattern-match-util'
import Icon from 'components/Icon'
import styles from './WorkpapersMenu.sass'
import WorkpapersViewModel from '../WorkpapersViewModel'

interface Props {
  workpapers: Array<WorkpapersViewModel>
  selectedWorkpaper: WorkpapersViewModel
  onItemClick: (workpaper: WorkpapersViewModel) => void
}

export default observer(function Menu({
  workpapers,
  selectedWorkpaper,
  onItemClick,
}: Props) {
  return (
    <ul className={cx(styles.menu)}>
      {workpapers.map((workpaper) => (
        <MenuItem
          key={Id.assert(workpaper.id)}
          workpaper={workpaper}
          isSelected={selectedWorkpaper.id === workpaper.id}
          onItemClick={onItemClick}
        />
      ))}
    </ul>
  )
})

interface MenuItemProps {
  workpaper: WorkpapersViewModel
  isSelected: boolean
  onItemClick: (workpaper: WorkpapersViewModel) => void
}

const MenuItem = observer(function MenuItem({
  workpaper,
  isSelected,
  onItemClick,
}: MenuItemProps) {
  return (
    <li
      data-test={`workpaper-sidemenu-item-${workpaper.title}`}
      className={cx(styles.menuItem, isSelected && styles.selected)}
      onClick={() => onItemClick(workpaper)}
    >
      {match(workpaper.extractionState, {
        Pending: () => (
          <span
            className={cx(styles.menuItemIcon, styles.pending)}
            data-test="workpaper-sidemenu-item-pending"
          >
            <Icon name="loader-arrows" size={24} />
          </span>
        ),
        Extracted: () => (
          <span
            className={cx(styles.menuItemIcon, styles.extracted)}
            data-test="workpaper-sidemenu-item-extracted"
          >
            <Icon name="alert" size={24} />
          </span>
        ),
        Validated: () => (
          <span
            className={cx(styles.menuItemIcon, styles.validated)}
            data-test="workpaper-sidemenu-item-validated"
          >
            <Icon name="tick" size={12} />
          </span>
        ),
        Unavailable: () => null,
      })}

      <span className={styles.menuItemContent}>
        <span className={styles.menuItemTitle}>{workpaper.title}</span>
        <span className={styles.menuItemStatus}>
          {match(workpaper.extractionState, {
            Pending: () => 'Processing',
            Extracted: () => 'Pending review',
            Validated: () => 'Approved',
            Unavailable: () => '',
          })}
        </span>
      </span>

      <span className={cx(styles.menuItemIcon)}>
        <Icon
          name="arrow"
          size={24}
          className={cx(isSelected && styles.selected)}
        />
      </span>
    </li>
  )
})
